import { Pipe, PipeTransform } from '@angular/core';
import { toIsoCurrency } from '../utils/xtm-currency.utils';

@Pipe({
  name: 'formatCurrency',
  standalone: true,
  pure: true,
})
export class FormatCurrencyPipe implements PipeTransform {
  transform(value: number, currency = 'USD'): string {
    const isoCode = toIsoCurrency(currency);
    const formatted = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
    return `${formatted} ${isoCode}`;
  }
}
